let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hBdsK")).then(() => parcelRequire('288Gr'));